import React from 'react';
import asyncComponent from '../../../util/asyncComponent';

import PrivateRoute from './PrivateRoute';
import { Route, Switch } from 'react-router-dom';

const Financeiro = asyncComponent(() => import('../financeiro'));

const PrestacaoContas = asyncComponent(() =>
  import('../financeiro/prestacaoContas/ListaPrestacaoContas')
);
const Repasses = asyncComponent(() =>
  import('../financeiro/repasses/ListaRepasses')
);
const NotaFiscal = asyncComponent(() =>
  import('../financeiro/notafiscal/ListaNotaFiscal')
);
const Faturas = asyncComponent(() =>
  import('../financeiro/faturas/ListaFaturas')
);
const Boletos = asyncComponent(() =>
  import('../financeiro/boletos/ListaBoletos')
);
const Pix = asyncComponent(() => import('../financeiro/pix/ListaPix'));
const BaixasRealizadas = asyncComponent(() =>
  import('../financeiro/baixas/ListaBaixaRealizadas')
);
const Baixar = asyncComponent(() =>
  import('../financeiro/baixas/BaixarRecebimento')
);
const BaixarSemAcordo = asyncComponent(() =>
  import('../financeiro/baixas/BaixarRecebimentoSemAcordo')
);
const FinanceiroLiberados = asyncComponent(() =>
  import('../financeiro/recebimentos/Liberados/ListaRecebimentos')
);
const ImportacaoRecebimentos = asyncComponent(() =>
  import('../financeiro/recebimentos/importacoes')
);
const BloqueadosIdentificar = asyncComponent(() =>
  import(
    '../financeiro/recebimentos/BloqueadosIdentificar/BloqueadosIdentificar'
  )
);
const ImportacaoRecebimentosBaixas = asyncComponent(() =>
  import('../financeiro/ImportacaoRecebimentosBaixas')
);
const MovimentacoesDeContas = asyncComponent(() =>
  import('../financeiro/MovimentacoesDeContas/ListaMovimentacaoContas')
);
const InstrucoesNegociadores = asyncComponent(() =>
  import('../financeiro/InstrucoesNegociador/ListaInstrucaoNegociador')
);
const ContasReceber = asyncComponent(() =>
  import('../financeiro/contasareceber/ListaContasReceber')
);
const ContasPagar = asyncComponent(() =>
  import('../financeiro/contasapagar/ListaContasPagar')
);
const Cheques = asyncComponent(() =>
  import('../financeiro/cheques/ListaCheques')
);
const AlegaPagamento = asyncComponent(() =>
  import('../financeiro/alegaPagamento')
);

export default function FinanceiroRoutes({ match }) {
  return (
    <>
      <Switch>
        <PrivateRoute
          path={`${match.url}/fin/baixas-realizadas`}
          component={BaixasRealizadas}
          codigo="fin_baixas_vis"
        />
        <PrivateRoute
          path={`${match.url}/fin/baixar/:id`}
          component={Baixar}
          codigo="fin_rec_baixar"
        />
        <PrivateRoute
          path={`${match.url}/fin/baixar-sem-acordo/:id`}
          component={BaixarSemAcordo}
          codigo="fin_rec_baixar"
        />
        <PrivateRoute
          path={`${match.url}/fin/recebimentos/liberados-baixa`}
          component={FinanceiroLiberados}
          codigo="fin_rec_vis"
        />
        <PrivateRoute
          path={`${match.url}/fin/recebimentos/importacoes`}
          component={ImportacaoRecebimentos}
          codigo="fin_rec_cad"
        />
        <PrivateRoute
          path={`${match.url}/fin/importar-recebimentos-baixas`}
          component={ImportacaoRecebimentosBaixas}
          codigo="fin_rec_bloq_vis"
        />
        <PrivateRoute
          path={`${match.url}/fin/prestacao-contas`}
          component={PrestacaoContas}
          codigo="fin_pc_vis"
        />
        <PrivateRoute
          path={`${match.url}/fin/repasses`}
          component={Repasses}
          codigo="fin_rep_vis"
        />
        <PrivateRoute
          path={`${match.url}/fin/nota-fiscal`}
          component={NotaFiscal}
          codigo="fin_nf"
        />
        <PrivateRoute
          path={`${match.url}/fin/faturas`}
          component={Faturas}
          codigo="fin_fat_vis"
        />
        <PrivateRoute
          path={`${match.url}/fin/boletos`}
          component={Boletos}
          codigo="fin_bol_vis"
        />
        <PrivateRoute
          path={`${match.url}/fin/pix`}
          component={Pix}
          codigo="fin_pix_vis"
        />
        <PrivateRoute
          path={`${match.url}/fin/cheques`}
          component={Cheques}
          codigo="fin_cheq_vis"
        />
        <PrivateRoute
          path={`${match.url}/fin/recebimentos/bloqueados-identificar`}
          component={BloqueadosIdentificar}
          codigo="fin_rec_bloq_vis"
        />
        <PrivateRoute
          path={`${match.url}/fin/mov-contas`}
          component={MovimentacoesDeContas}
          codigo="fin_movc_vis"
        />
        <PrivateRoute
          path={`${match.url}/fin/contas-a-receber`}
          component={ContasReceber}
          codigo="fin_crec_vis"
        />
        <PrivateRoute
          path={`${match.url}/fin/contas-a-pagar`}
          component={ContasPagar}
          codigo="fin_cpag_vis"
        />
        <PrivateRoute
          path={`${match.url}/fin/portal-alega-pagamento`}
          component={AlegaPagamento}
          codigo="fin_alega_pag"
        />
        <Route
          path={`${match.url}/fin/instrucoes-negociadores`}
          component={InstrucoesNegociadores}
        />

        <PrivateRoute
          path={`${match.url}/fin/inicio`}
          component={Financeiro}
          codigo="fin"
        />
        <PrivateRoute
          exact
          path={`${match.url}/fin`}
          component={Financeiro}
          codigo="fin"
        />
      </Switch>
    </>
  );
}
